module.exports = __webpack_public_path__ + "img/egg_melons_happy.80ae73f6.svg";